export default "__VITE_ASSET__4c5f34d8__"